export const identify = (id, attributes) => {
  window._cd.identify(id, attributes);
};

export const track = (event, properties) => {
  window._cd.trackEvent(event, properties);
};
